import { platform } from 'constants'
import React from 'react'

import { GridItem } from 'partials/UpspaceTabs/widgets/subcomponents/GridItem'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { Title } from 'widgets/Title'

import commonStyles from 'utils/styles/commonStyles'

import { Post } from 'types/post'

export const TrendingWorkouts = ({
  discoverContent,
  isLoadingDiscoverContent,
  trendingWorkouts,
  isLoadingTrendingWorkouts,
}) => {
  return (
    <>
      <Title bold>{discoverContent?.sections[1]?.name}</Title>
      {!isLoadingTrendingWorkouts && (
        <Box
          testID='TrendingWorkoutsRow'
          flexDirection={trendingWorkouts && trendingWorkouts.length > 0 ? 'row' : 'column'}
          justifyContent='flex-start'
          width='100%'
          margin={{ bottom: 'md' }}
          padding={{ bottom: 'smd' }}
          style={platform.IS_WEB ? commonStyles.overflowScroll : undefined}
        >
          <FlatList<Post>
            horizontal
            showsHorizontalScrollIndicator
            data={trendingWorkouts}
            loading={isLoadingTrendingWorkouts}
            renderItem={({ item: post }) => <GridItem key={post.id} post={post} isUpspaceItem />}
            keyExtractor={(post) => {
              return post.id
            }}
            testID='TrendingWorkoutsList'
            noContentProps={{
              marginTop: 50,
              marginBottom: 50,
              message: 'No workouts are trending right now',
            }}
            contentContainerStyle={commonStyles.flexGrow}
          />
        </Box>
      )}
    </>
  )
}
